import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth/auth.service';
import * as jwt_decode from 'jwt-decode';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef } from "@angular/material/dialog";
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { MatRadioChange, MatRadioButton } from '@angular/material/radio';
import { LoginRequestVM } from 'src/app/viewModels/login/login-request-vm';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { TokenValidateRequestVM } from 'src/app/viewModels/login/token-validate-request-vm';
import { CommonService } from 'src/app/middleware/common/common.service';
import { CommonDialogComponent } from 'src/app/middleware/shared/dialogueBoxes/common/common-dialog.component';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { CustomvalidationService } from 'src/app/middleware/common/resuableServices/validatorServices';
import { CookieService } from 'ngx-cookie-service';
import { Subscription, timer } from 'rxjs';
import { HttpClient,HttpBackend } from '@angular/common/http';
import { DatePipe } from '@angular/common';
const { detect } = require('detect-browser');
const browser = detect();

@Component({
  selector: 'app-PortalLogin',
  templateUrl: './PortalLogin.component.html',
  styleUrls: ['./PortalLogin.component.scss'],
  providers: [DatePipe]
})
export class PortalLoginComponent implements OnInit {
  verifyToken: any;
  recaptchaReactive: boolean=false;
  isShowrecaptchaReactive: boolean=false;

  constructor(private http: HttpClient,private activatedRoute: ActivatedRoute,private httpbackend:HttpBackend,private _formBuilder: FormBuilder,
    private loginRequestVM: LoginRequestVM, private encryptionAlgo: EncryptionService, 
    private reusableClass: ReusableClasses, private authService: AuthService, private statusConst: StatusConstant,
    private tokenValidationReqVM: TokenValidateRequestVM, private commonService: CommonService,
    private matDialog: MatDialog, public dialogRef: MatDialogRef<CommonDialogComponent>,
    private loaderService: LoaderService, private toastr: ToastrService, private router: Router,
    private constant: Constants,private dialog: MatDialog,
    private customValidator: CustomvalidationService,private cookieService: CookieService,
    public datepipe: DatePipe) {
      var skipper = new HttpClient(httpbackend);
      skipper.get<{ip:string}>('https://jsonip.com').subscribe( data => {       
        this.ipAddress = data.ip;
      });
  }

  ipAddress:any;
  browsername:any;
  device:any;

  //Observables and Variables will go here...
  loginForm: FormGroup;
  loginResponseHolder: any;
  loginToken: any;
  twofactorToken: any;
  validateTokenResponseHolder: any;
  decodedUserData: any;
  password: any = "";
  enableLoginButton: boolean = false;
  displayValidatorField: boolean = false;
  tokenValidator: any;
  enableConfirmButton: boolean = false;
  showLoginForm: boolean = false;
  permissionsAssigned: any[] = [];
  organizationID: any;
  databaseID: any;
  folderAccess: any[] = [];
  Email:string="";
  Token:string="";
  hidenew = true;
  rememberMe:boolean=false;
  LoggedInEmailId:string="";
  ContinueButton:boolean=false;
  passworderror:string="";
  spinner:boolean=false;
  //Observables and Variables will go here...
  menuModules: any[] = [];
  browserversion:string="";
  associatedAPIs: any[] = [];
  private queryParamSubscription: Subscription;
  ngOnInit(): void {
    this.recaptchaReactive=false;
    this.CheckLoginTokenEXpiry();
    // this.queryParamSubscription = this.activatedRoute.queryParams.subscribe(params => {
    //   // Here, 'params' is an object containing the query parameters
    //   this.verifyToken = params['token']; // Replace 'myParam' with the name of your query parameter
    //   // Now you can use 'myParam' as needed
    //   if(params['token']!=undefined && params['token']!=null)
    //   {
    //     this.VerifyNewIp();
    //   }
    // });
    if (browser) {
      this.browsername = browser.name;
      this.device = browser.os;
      this.browserversion = browser.version;
    }
    this.loginForm = this._formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
    
    // let token = sessionStorage.getItem('userToken');
    // let menuModules = sessionStorage.getItem('menuModules');
    // if((token == undefined || token == null || token == '') || (menuModules == undefined || menuModules == null || menuModules == '')) {
    //  // this.getQueryParameter();          
    //   // var useremail=sessionStorage.getItem("UserActivationEmail");
    //   // var usertoken = sessionStorage.getItem("UserActivationToken");
    //   // if(useremail != undefined && useremail != null && useremail != '' && usertoken != undefined && usertoken != null && usertoken != ''){
    //   //   this.Email=sessionStorage.getItem("UserActivationEmail");
    //   //   this.Token=sessionStorage.getItem("UserActivationToken");
    //   //   this.VerifyEmail();
    //   // }
    //   //this.logout();
    //   if (!sessionStorage.getItem('foo')) {
    //     //sessionStorage.setItem('foo', 'no reload');
    //     //location.reload(); 
    //   } else {
    //     //this.getQueryParameter();
    //     sessionStorage.removeItem('foo');
    //   }     
    // }
    // else{
    //     // sessionStorage.setItem('HeaderModuleName','Dashboard');
    //     // this.router.navigate(['/dashboard']);
    //     // return;     
    // }
  }


 
  public addTokenLog(message: boolean, token: string | null) {
    this.recaptchaReactive=message;
  }

  public onError() {

  }

  public formatToken(token: string | null) {
    return token !== null
      ? `${token.substring(0, 7)}...${token.substring(token.length - 7)}`
      : 'null';
  }

  otp:string="";
  display: string="";
  interval: any;

  totalTime: number;
  min: number;
  sec: number;
  subscribe: any;
  clockTimer: string = '00 : 00';  
diableLogin(loginFormcons:any)
{
  if(this.isShowrecaptchaReactive==true && this.recaptchaReactive==false && loginFormcons.invalid)
    {
     return true;
    }
    else if(this.isShowrecaptchaReactive==true && this.recaptchaReactive==true && loginFormcons.invalid)
      {
        return true;
      }
      else if(this.isShowrecaptchaReactive==true && this.recaptchaReactive==false && !loginFormcons.invalid)
        {
          return true;
        }
      else if (this.isShowrecaptchaReactive==true && this.recaptchaReactive==true && !loginFormcons.invalid)
      {
      return false;
      }
      else if (this.isShowrecaptchaReactive==false  && loginFormcons.invalid)
        {
        return true;
        }
        else if (this.isShowrecaptchaReactive==false  && !loginFormcons.invalid)
          {
          return false;
          }
}
  login(form:any){
    sessionStorage.setItem('portalemail', form.value.email);
      var reqModel={
        LoginIp: this.ipAddress,
        device: this.device,
        browser: this.browsername + ' ' +this.browserversion,
        email: form.value.email,
        recaptchaReactive:this.recaptchaReactive
      }
      this.loaderService.show();
      this.spinner=true;
      this.authService.HandleLogin(reqModel).subscribe(response => {
     let  responseHolder:any;
     responseHolder=response;
        if (responseHolder.data.tokenStatus==3) {
          this.showLoginForm=true;
          responseHolder = response;
          this.toastr.success("Kindly input the One-Time Password (OTP) that has been sent to your registered email address.", '', {
            timeOut: 3000,
          });
          this.loaderService.hide();
          this.spinner=false;
        }
        if (responseHolder.data.tokenStatus==2) {
          this.showLoginForm=false;
          responseHolder = response;
          this.toastr.warning("We've sent a verification link to your email. Please click on it to confirm your identity", '', {
            timeOut: 3000,
          });
          this.loaderService.hide();
          this.spinner=false;
        }
        if (responseHolder.data.tokenStatus==6) {
          this.showLoginForm=false;
          this.isShowrecaptchaReactive=true;
          responseHolder = response;
          this.toastr.warning("Please Verify Captcha to register email", '', {
            timeOut: 3000,
          });
          this.loaderService.hide();
          this.spinner=false;
        }
        if (responseHolder.data.tokenStatus==7) {
          this.showLoginForm=false;
          responseHolder = response;
          this.toastr.warning("Backend error, Kindly connect to support for help.", '', {
            timeOut: 3000,
          });
          
          this.loaderService.hide();
          this.spinner=false;
        }
        // if (responseHolder.data.tokenStatus==8) {
        //   this.showLoginForm=false;
        //   this.isShowrecaptchaReactive=true;
        //   responseHolder = response;
        //   this.toastr.warning("Please Verify Captcha", '', {
        //     timeOut: 3000,
        //   });
          
        //   this.loaderService.hide();
        //   this.spinner=false;
        // }
      });
    }    
  
  showLogin(){
    this.showLoginForm=false;  
  }

  MatchOTP(){
    if(this.otp==""){
      this.toastr.warning("Please Enter Otp", '', {
        timeOut: 3000,
      });
      return;
    }
    else{
      var reqModel={
        LoginIp: this.ipAddress,
        OTP: this.otp,
        email: sessionStorage.getItem('portalemail')
      }
      this.loaderService.show();
      this.spinner=true;
      this.authService.MatchOTP(reqModel).subscribe(response => {
      let  responseHolder:any;
       responseHolder=response;
        if (responseHolder.data.tokenStatus==5) {
          responseHolder = response;
          this.toastr.warning("The OTP you entered does not match our records. Please double-check and try again.", '', {
            timeOut: 3000,
          });
          this.loaderService.hide();
          this.spinner=false;
        }
        else {
          responseHolder = response;
          this.toastr.success("You have successfully logged in. Welcome!", '', {
            timeOut: 3000,
          });
          this.loaderService.hide();
          this.spinner=false;
          sessionStorage.setItem('LoginToken',responseHolder.data.token);
          this.router.navigate([`/request/portal`]);
        }
      });
    }   
  }

  // VerifyNewIp(){
  //     var reqModel={
  //       Token: this.verifyToken,
  //       OTP: this.otp,
  //       email: sessionStorage.getItem('portalemail')
  //     }
  //     this.loaderService.show();
  //     this.spinner=true;
  //     this.authService.VerifyNewIp(reqModel).subscribe(response => {
  //    let  responseHolder:any;
  //    responseHolder=response;
  //       if (responseHolder.data) {
  //         this.verifyToken=undefined;
  //         responseHolder = response;
  //         this.toastr.success("New IP authorized successfully", '', {
  //           timeOut: 3000,
  //         });
  //         this.loaderService.hide();
  //         this.spinner=false;
  //       }
  //     });
  // }

  CheckLoginTokenEXpiry(){
    if(sessionStorage.getItem('LoginToken')!=null && sessionStorage.getItem('LoginToken')!=undefined){
       var reqModel={
         email: sessionStorage.getItem('portalemail')
       };
       this.loaderService.show();
       this.spinner=true;
       this.authService.CheckLoginTokenEXpiry(reqModel).subscribe(response => {
       let  responseHolder:any;
       responseHolder=response;
         if (responseHolder.data) {
           responseHolder = response;
           this.toastr.warning("Login token expired", '', {
             timeOut: 3000,
           });
           this.loaderService.hide();
           this.spinner=false;
           sessionStorage.removeItem('LoginToken')
           sessionStorage.removeItem('portalemail')
           this.router.navigate([`/auth/portallogin`]);
         }else{
           this.router.navigate([`/request/portal`]);
         }
       });
   }
}

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

}
